// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-box {
  display: flex;
  padding: 0.5rem;
  border: 1px solid var(--gc-border-color);
}

.color {
  width: 85px;
  height: 55px;
  border-radius: 3px;
}

.grid-box {
  display: grid;
  grid-template-columns: [dataA] 1fr [dataB] 1fr;
  height: 100%;
  gap: 0.5rem;
}
.grid-box .left {
  grid-column: dataA;
}
.grid-box .right {
  grid-column: dataB;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-event-template-summary/v-event-template-summary.component.sass"],"names":[],"mappings":"AAAA;EAGI,aAAA;EACA,eAAA;EACA,wCAAA;AADJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAEA;EACI,aAAA;EACA,8CAAA;EACA,YAAA;EACA,WAAA;AACJ;AAAI;EACI,kBAAA;AAER;AADI;EACI,kBAAA;AAGR","sourcesContent":[".summary-box\n    // padding: 0.5rem\n    // flex: 100%\n    display: flex\n    padding: 0.5rem\n    border: 1px solid var(--gc-border-color)\n\n.color\n    width: 85px\n    height: 55px\n    border-radius: 3px\n\n.grid-box\n    display: grid\n    grid-template-columns: [dataA] 1fr [dataB] 1fr\n    height: 100%\n    gap: 0.5rem\n    .left\n        grid-column: dataA\n    .right\n        grid-column: dataB"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
